import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import Validators from '../../utils/validators'

@observer(['backends'])
export default class Backends extends Component {

  constructor(props) {
    super(props)

    this.props.backends.loadAllBackends()
  }

  newBackend(row) {
    this.props.backends.newBackend(row.name)
  }

  updateBackend(row, cellText, cellValue) {
    this.props.backends.updateBackend(row.id, cellValue)
  }

  deleteBackend(id) {
    if (confirm('Are you sure you want to delete this Backend?')) {
      this.props.backends.deleteBackend(id)
    }
  }

  formatActions(cell, row) {
    return <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteBackend(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
  }

  render() {
    const options = {
      onAddRow: this.newBackend.bind(this)
    }

    const backendsTable = (
      <BootstrapTable
          data={ this.props.backends.data }
          striped={ true }
          hover={ true }
          pagination={ true }
          search={ true }
          exportCSV={ true }
          options={ options }
          insertRow={ true }
          bordered={ false }
          cellEdit={ { mode: 'click', blurToSave: false, afterSaveCell: this.updateBackend.bind(this) } } >
        <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="name" dataSort={ true } editable={{ validator: Validators.validString }}>Name</TableHeaderColumn>
        <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
      </BootstrapTable>
    )

    return (
      <div>
        <Collapsible title="Backends" content={ backendsTable } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/backends.js